import { useEffect } from 'react';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { useAppDispatch } from '.';
import { setIsInDemoApp } from '../reducers/AppConfig';
const useIsInDemoApp = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const fullUrl = getFullUrl(enviro.deployed() ? 'app' : 'local');
    const handleMessage = event => {
      var _event$data;
      if (event.origin === fullUrl && ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.name) === 'GROWTH_ONBOARDING_DEMO_TOUR:INITIATED') {
        dispatch(setIsInDemoApp({
          isInDemoApp: true
        }));
      }
    };
    if (window.GROWTH_ONBOARDING_DEMO_TOUR) {
      dispatch(setIsInDemoApp({
        isInDemoApp: true
      }));
    } else {
      window.addEventListener('message', handleMessage);
    }
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [dispatch]);
};
export default useIsInDemoApp;